import React from 'react';
import { DocumentLibraryContext } from '../../../providers';
export const useSelectFilesDialogNavigation = ({ rootDirectoryId }) => {
    var _a;
    const documentLibraryContext = React.useContext(DocumentLibraryContext);
    const allParents = (_a = documentLibraryContext.parents) !== null && _a !== void 0 ? _a : [];
    const rootDirectoryIndex = rootDirectoryId ? allParents.findIndex((directory) => directory.id === rootDirectoryId) : -1;
    const parentsBelowRootDirectory = rootDirectoryIndex >= 0 ? allParents.slice(rootDirectoryIndex + 1) : allParents;
    const handleNavigateTo = (target) => {
        const targetString = target && typeof target === 'object' && 'pathname' in target && target.pathname ? target.pathname : target === null || target === void 0 ? void 0 : target.toString();
        documentLibraryContext.handleCurrentDirectoryId(targetString);
    };
    const handleNavigateBack = () => { var _a; return handleNavigateTo((_a = parentsBelowRootDirectory.at(-2)) === null || _a === void 0 ? void 0 : _a.id); };
    return {
        handleNavigateBack,
        handleNavigateTo,
        parentsBelowRootDirectory,
    };
};
